var map = {
	"./ca-AD.json": 1466,
	"./ca-ES.json": 1467,
	"./en-US.json": 1468,
	"./es-AR.json": 1469,
	"./es-CL.json": 1470,
	"./es-CO.json": 1471,
	"./es-ES.json": 1472,
	"./es-MX.json": 1473,
	"./eu-ES.json": 1474,
	"./fr-FR.json": 1475,
	"./it-IT.json": 1476
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1465;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*\.json$
// module id = 1465
// module chunks = 22